/** Namespace `components` — `src/components/*` + `metric-format.ts`. */
export const components = {
  "quality.approx": "Ước tính",
  "quality.stale": "Cũ",
  "quality.missing": "Chưa có số",
  "quality.drift": "Lệch schema",
  "quality.unsupported": "Không hỗ trợ",
  "quality.not_configured": "Chưa cấu hình",
  basisMissing: "Chưa khai cơ sở đo.",
  basis: "Cơ sở đo: {basis}",
  basisWithDesc: "Cơ sở đo « {basis} »: {desc}",
  valueAt: "Số lúc {at}",
  updatedAt: "Cập nhật {at}",
  // AppBreakdown
  "breakdown.title": "Theo từng app",
  "breakdown.viewOne": "Xem riêng {name}",
  "breakdown.count": "{measured}/{total} app có số",
  "breakdown.search": "Tìm app…",
  "breakdown.app": "App",
  "breakdown.updated": "Cập nhật",
  "breakdown.noMatch": "Không có app nào khớp.",
  "breakdown.noData": "{count} app chưa có số",
  "breakdown.total": "Tổng",
  "breakdown.new": "Mới",
  "breakdown.active": "Hoạt động",
  // AppFilter
  "appFilter.ariaLabel": "Chọn app",
  "viewing.prefix": "Đang xem:",
  "viewing.single": "— số của riêng app này.",
  // PeriodSelect
  "periodSelect.ariaLabel": "Kỳ xem",
  "periodSelect.from": "Từ ngày",
  "periodSelect.to": "Đến ngày",
  "periodSelect.reversed": "Ngày đầu phải trước ngày cuối.",
  // SeriesChart
  "chart.emptyBefore": "Chưa có dữ liệu nào cho",
  "chart.emptyAfter": "trong kỳ này.",
  "chart.noData": "{date}: không có dữ liệu",
  "chart.approx": " (ước tính — tổng các nguồn, có thể đếm trùng người dùng chung)",
  "chart.stale": " (số lúc {at})",
  "chart.unknown": "không rõ",
} as const;
